<template functional>
  <span v-if="props.country">
    <span
      v-if="
        props.showFlag &&
          props.country.alpha2 &&
          typeof props.country.alpha2 === 'string'
      "
      :title="props.country.name"
      :class="`flag-icon fi fi-${props.country.alpha2.toLowerCase()}`"
    />
    <template v-if="props.showIoc"> {{ props.country.ioc }}</template
    ><slot name="append" />
  </span>
</template>
<script>
import gql from "fraql";
export default {
  name: "AppShowCountry",
  props: {
    country: {
      type: Object,
      default: null
    },
    showFlag: {
      type: Boolean,
      default: true
    },
    showIoc: {
      type: Boolean,
      default: true
    }
  },
  fragments: {
    country: gql`
      fragment _ on Country {
        id
        name
        alpha2
        ioc
      }
    `
  }
};
</script>
